import React, { useEffect } from "react";
import "../../styles/filters-form.less";
import { useDispatch } from "react-redux";
import {
  fetchChargeNameTypeStatus,
  fetchProducts,
  fetchServiceMode,
} from "../../store/slices/rtkDictionaries";
import { fetchServiceTypesAdmin, fetchTaxesRates } from "../../store/slices/service-types";
import ServiceTypeCreateForm from "../../components/ServiceTypeCreateForm/ServiceTypeCreateForm";

// eslint-disable-next-line consistent-return
const ServiceTypeCreateFormContainer = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchServiceMode());
    dispatch(fetchProducts());
    dispatch(fetchChargeNameTypeStatus());
    dispatch(fetchServiceTypesAdmin());
    dispatch(fetchTaxesRates());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="container_height">
      <ServiceTypeCreateForm />
    </div>
  );
};

export default ServiceTypeCreateFormContainer;
